import BottomRow from "./BottomRow";
import Column from "theme/layouts/Column";
import FooterNavigation from "./FooterNavigation";
import Grid from "theme/layouts/Grid";
import Newsletter from "theme/components/newsletter/Newsletter";
import React from "react";
import SocialMedia from "./SocialMedia";
import TextStyles from "theme/components/text/TextStyles";
import WallmekLogo from "theme/components/icons/WallmekLogo";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const StyledFooter = styled("footer")`
    display: grid;
    gap: 56px;
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.colors.blue_900};
    color: ${({ theme }) => theme.colors.white};

    ${({ theme }) => theme.above.tabletLg} {
        gap: 96px;
    }
`;

const StyledText = styled(TextStyles)`
    // handle line breaks
    :empty {
        margin-bottom: 1em;
    }
`;

const Section = styled(Column)`
    ${({ theme }) => theme.above.tabletLg} {
        gap: 24px;
        flex-direction: row;
    }
`;

const Footer = () => {
    const { t } = useTranslation();
    const ecommerceEnabled = useSelector(({ application }) => application?.ecommerceEnabled);
    const contactInformation = useSelector(({ footer }) => footer.data?.company_information) || [];

    return (
        <StyledFooter
            id="site-footer"
            p={["32px 20px 16px", null, null, null, "48px 48px 24px"]}
            mt={["64px", null, null, null, "104px"]}
        >
            <WallmekLogo height="auto" width="min(100%, 1920px)" color="currentColor" />

            <Grid columns={["1", null, null, null, "2"]} columnGap="24px" rowGap={["64px", null, null, null, "24px"]}>
                <Section as="section">
                    {!!contactInformation?.length && (
                        <Column as="article" gap="12px" width="100%" pb={["56px", null, null, null, "0"]}>
                            <TextStyles as="h2" textStyles="Myriad Pro/18-100-semibold-semiextended">
                                {t("footer.heading.contact")}
                            </TextStyles>
                            <div>
                                <Wysiwyg
                                    data={contactInformation}
                                    textComponent={(props) => (
                                        <StyledText
                                            textStyles={["Myriad Pro/16-140", null, null, null, "Myriad Pro/14-140"]}
                                            {...props}
                                        />
                                    )}
                                />
                            </div>
                        </Column>
                    )}

                    <FooterNavigation />
                    <SocialMedia />
                </Section>
                <Newsletter gridRow={["1", null, null, null, "unset"]} />
            </Grid>

            <BottomRow />
        </StyledFooter>
    );
};

export default Footer;
